import { Component, OnInit } from '@angular/core';
import { AppNavigationHeaderComponent } from '../../../components/navigation-header/app-navigation-header.component';
import { BillingListTableComponent } from '../billing-list-table/billing-list-table.component';
import { BreadcrumbLabelDirective } from '../../../directives/breadcrumb-label.directive';

@Component({
	selector: 'app-billing-main-tab',
	templateUrl: './billing-main-tab.component.html',
	styleUrls: ['./billing-main-tab.component.scss'],
	imports: [
		AppNavigationHeaderComponent,
		BillingListTableComponent,
		BreadcrumbLabelDirective,
	],
})
export class BillingMainTabComponent {
	billingListBreadcrumbLabel = $localize`:@@billingMainTab-billingListBreadcrumbLabel:Billing`;
	constructor() {}
}
